import React, { Component } from 'react';

export default class CommandPalette extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      highlightIndex: 0,
      selectedToolId: null,
    };

    this.inputRef = React.createRef();
  }

  componentDidMount() {
    if (this.inputRef.current) {
      this.inputRef.current.focus();
    }
    window.addEventListener('keydown', this.onKeyDown);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.highlightIndex !== this.state.highlightIndex) {
      const activeItem = document.querySelector('.tt-item.is-active');
      if (activeItem) {
        activeItem.scrollIntoView({ block: 'nearest' });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown = (e) => {
    const { selectedToolId, query, highlightIndex } = this.state;
    const { tools } = this.props;

    if (selectedToolId) {
      // In tool view: only Esc returns to list
      if (e.key === 'Escape') {
        e.preventDefault();
        this.setState({ selectedToolId: null });
        setTimeout(() => {
          if (this.inputRef.current) {
            this.inputRef.current.focus();
          }
        }, 0);
      }
      return;
    }

    // In list view: handle navigation and selection
    const filtered = this.getFilteredTools();

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (filtered.length > 0) {
        this.setState({
          highlightIndex: (highlightIndex + 1) % filtered.length,
        });
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (filtered.length > 0) {
        this.setState({
          highlightIndex: (highlightIndex - 1 + filtered.length) % filtered.length,
        });
      }
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (filtered.length > 0) {
        const selected = filtered[highlightIndex];
        this.setState({ selectedToolId: selected.id });
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      this.props.onClose();
    }
  };

  getFilteredTools = () => {
    const { tools } = this.props;
    const { query } = this.state;
    const trimmed = query.trim().toLowerCase();

    return tools.filter(
      t => t.label.toLowerCase().indexOf(trimmed) !== -1
    );
  };

  handleQueryChange = (e) => {
    this.setState({ query: e.target.value, highlightIndex: 0 });
  };

  handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      this.props.onClose();
    }
  };

  handleToolSelect = (toolId) => {
    this.setState({ selectedToolId: toolId });
  };

  handleToolRowEnter = (index) => {
    this.setState({ highlightIndex: index });
  };

  handleBackToList = () => {
    this.setState({ selectedToolId: null });
    setTimeout(() => {
      if (this.inputRef.current) {
        this.inputRef.current.focus();
      }
    }, 0);
  };

  render() {
    const { tools, onClose } = this.props;
    const { selectedToolId, query, highlightIndex } = this.state;

    if (selectedToolId) {
      const selected = tools.filter(t => t.id === selectedToolId)[0];
      if (!selected) return null;

      const ToolComponent = selected.component;

      return (
        <div className="tt-overlay" onClick={this.handleBackdropClick}>
          <div className="tt-palette">
            <div className="tt-tool-header">
              <button
                className="tt-back"
                onClick={this.handleBackToList}
                type="button"
                aria-label="Back to tools"
              >
                ←
              </button>
              <div className="tt-tool-title">{selected.label}</div>
            </div>
            <div className="tt-tool-body">
              <ToolComponent onClose={onClose} />
            </div>
          </div>
        </div>
      );
    }

    const filtered = this.getFilteredTools();

    return (
      <div className="tt-overlay" onClick={this.handleBackdropClick}>
        <div className="tt-palette">
          <input
            ref={this.inputRef}
            type="text"
            className="tt-search"
            placeholder="Search tools…"
            value={query}
            onChange={this.handleQueryChange}
          />

          {filtered.length === 0 ? (
            <div className="tt-empty">No tools found</div>
          ) : (
            <div className="tt-list">
              {filtered.map((tool, index) => (
                <div
                  key={tool.id}
                  className={'tt-item' + (highlightIndex === index ? ' is-active' : '')}
                  onMouseEnter={() => this.handleToolRowEnter(index)}
                  onClick={() => this.handleToolSelect(tool.id)}
                >
                  <div className="tt-item-content">
                    <div className="tt-item-label">{tool.label}</div>
                    {tool.description && (
                      <div className="tt-item-desc">{tool.description}</div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="tt-footer">
            <div>
              <span className="tt-key">↵</span>
              Open
            </div>
            <div>
              <span className="tt-key">esc</span>
              Close
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/test-tools/CommandPalette.js